<div class="container-fluid main-container" class="mw100">
  <div class="row">
    <div class="col-md-12">
      <div class="container-fluid">
        <div class="row">
          <div class="font-weight-bold">Date Range</div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <nj-radio-group errorMessage="" [(value)]="SearchCurrentAndFuture" [hasError]="false" orientation="row">
              <nj-radio inputId="RDRViewCurrentAndFuure" name="RDRView" value="ShowActiveAndFutrure">
                Show Active and future
              </nj-radio>
              <nj-radio inputId="RDRViewHistorical" name="RDRView" value="ShowHistorical">
                Show Historical Instructions
              </nj-radio>
            </nj-radio-group>
          </div>
          <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false"
              [isDisabled]="SearchCurrentAndFuture == 'ShowActiveAndFutrure'" [hasCustomIcon]="false"
              [isFloatingLabel]="true" iconName="" inputId="RDRBDateFrom">
              <input type="date" id="RDRBDateFrom" njFormField [valueAsDate]="SearchDateFrom"
                (input)="SetDateFrom($event.target)" />
              <ng-container njFormLabel>Date From</ng-container>
              <ng-container njFormSubscript></ng-container>
            </nj-form-item>
            <nj-form-item [hasError]="false" [hasHint]="false"
              [isDisabled]="SearchCurrentAndFuture == 'ShowActiveAndFutrure'" [hasCustomIcon]="false"
              [isFloatingLabel]="true" iconName="" inputId="RDRBDateTo">
              <input type="date" id="RDRBDateTo" njFormField [valueAsDate]="SearchDateTo"
                (input)="SetDateTo($event.target)" />
              <ng-container njFormLabel>Date To</ng-container>
              <ng-container njFormSubscript></ng-container>
            </nj-form-item>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div [style]="'padding: 16px'" [style.background]="'transparent'">
      <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
        (buttonClick)="GetInstructions()">
        Search
      </nj-button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div><b>First Hydro Instructions</b></div>
      <div>Last refresh: {{ FHCLastRefresh }}</div>
    </div>
    <div class="col-md-6 text-right">
      @if(UserData.IsReadOnly == false && UserData.HasFHCAccess) {
      <nj-button size="normal" type="button" icon="" [hasCustomIcon]="false"
        [style]="'padding-left: 15px; margin-top: -5px;'" (buttonClick)="AddNewInstruction()">
        Add New
      </nj-button>
      }
    </div>
  </div>
  <div class="scroll-container">
    <app-fhc-instructions [GridData]="FHCIntructionsData"
      (OnViewInstruction)="ViewInstruction($event, false)"></app-fhc-instructions>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div><b>Ad Hoc Instructions</b></div>
    </div>
    <div class="col-md-6 text-right">
      @if(UserData.IsReadOnly == false && UserData.HasFHCAccess) {
      <nj-button size="normal" type="button" icon="" [hasCustomIcon]="false"
        [style]="'padding-left: 15px; margin-top: -5px;'" (buttonClick)="AddNewAdHocInstruction()">
        Add New
      </nj-button>
      }
    </div>
  </div>
  <div class="scroll-container">
    <app-adhoc-instructions [GridData]="FHCAdHocData"
      (OnViewInstruction)="ViewInstruction($event, true)"></app-adhoc-instructions>
  </div>
</div>